<template>
  <div class="card card-custom gutter-b example example-compact">
    <h2 class="soha-page-title line-height-xl text-center text-sm-left p-4">
      <img src="/media/svg/soha/icons/upload-file.svg" width="30" height="30" />
      {{ $t(`${I18nPrefix}PAGE_TITLE`) }} ({{ jobTitle }})
    </h2>
    <div class="card-body soha-height-card">
      <div class="row">
        <div class="col col-12">
          <div class="text-center mt-2 mb-6 p-5 soha-mass-upload-description">
            {{ $t(`${I18nPrefix}DESCRIPTION`) }}
          </div>
        </div>
        <div class="col col-12">
          <soha-checkbox
            name="dontExtractResumeData"
            :label="$t(`${I18nPrefix}FAST_UPLOAD_WITHOUT_EXTRACT_TEXT`)"
            checkbox-id="dontExtractResumeData"
            v-model="dontExtractResumeData"
            :disable="readyToSubmit"
            class="my-5"
          />
        </div>
        <div class="col col-12">
          <div
            class="soha-draggable-card bg-gray"
            @drop="fileDropped"
            @dragover="fileDragover"
            @dragleave="fileDragleave"
          >
            <input
              name="fileInput"
              class="d-none"
              ref="massResumes"
              id="attachFileInTimeLine"
              type="file"
              multiple
              v-on:change="filesSelected"
            />
            <label class="block">
              <div class="w-100">
                <img src="/media/svg/soha/icons/upload-file.svg" class="mb-6" />
                <br />
                <span class="soha-upload-box-text">
                  {{ $t(`${I18nPrefix}DRAG_AND_DROP_FILE`) }}

                  <span
                    name="insertFile"
                    class="soha-attach-file-click mx-1"
                    @click="$refs.massResumes.click()"
                  >
                    {{ $t(`${I18nPrefix}HERE`) }}
                  </span>

                  {{ $t(`${I18nPrefix}CLICKED`) }}
                </span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div
        v-for="(resume, index) in resumeFiles"
        v-bind:key="index"
        class="row mt-5"
      >
        <div class="row mr-4 ml-4 mass-resume-item-box px-7 py-4">
          <div class="d-flex ml-1 justify-content-between w-100">
            <div class="d-flex align-items-center">
              <strong class="m-2"> {{ $t(`${I18nPrefix}FILE_NAME`) }} </strong
              >{{ resume.name }}
            </div>

            <div class="d-flex align-items-center">
              <soha-button
                :class="{ 'mr-10': response[index].submitted }"
                v-if="!response[index].uploading"
                @click="viewResumeFile(index)"
                height="40"
                width="120"
                :text="
                  response[index].showResumeFile
                    ? $t(`${I18nPrefix}CLOSE_FILE`)
                    : $t(`${I18nPrefix}SHOW_FILE`)
                "
              />
              <loading
                size="14"
                v-if="response[index].uploading"
                class="mt-3"
              />
              <img
                v-if="response[index].submitted"
                height="45"
                width="45"
                :src="`/media/svg/soha/icons/check.svg`"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <soha-text-field
                name="name"
                v-if="response[index].resumeText"
                v-model.trim="response[index].name"
                :error="errors[index].nameError"
                class="w-100"
                :placeholder="$t(`${I18nPrefix}NAME_PLACEHOLDER`)"
              />
            </div>
            <div class="col-md-3">
              <soha-text-field
                name="family"
                v-if="response[index].resumeText"
                v-model.trim="response[index].family"
                :error="errors[index].familyError"
                class="w-100"
                :placeholder="$t(`${I18nPrefix}FAMILY_PLACEHOLDER`)"
              />
            </div>
            <div class="col-md-3">
              <soha-text-field
                name="phone"
                v-if="response[index].resumeText"
                v-model.trim="response[index].phone"
                :error="errors[index].phoneError"
                class="w-100"
                :placeholder="$t(`${I18nPrefix}PHONE_PLACEHOLDER`)"
              />
            </div>
            <div class="col-md-3">
              <soha-text-field
                name="email"
                v-if="response[index].resumeText"
                v-model.trim="response[index].email"
                :error="errors[index].emailError"
                class="w-100"
                :placeholder="$t(`${I18nPrefix}EMAIL_PLACEHOLDER`)"
              />
            </div>
          </div>
          <div
            class="row"
            style="width: 120%"
            v-if="response[index].showResumeFile"
          >
            <div class="col col-12">
              <iframe
                frameborder="0"
                data-action="load->iframe#onLoad"
                scrolling="no"
                data-controller="iframe"
                v-resize="{ log: false }"
                class="soha-mass-upload-pdf-box"
                :src="`/pdf-viewer/web/index.html?file=${response[index].fileUrl}`"
              />
            </div>
          </div>
        </div>
      </div>
      <soha-button
        name="submit"
        class="mt-4 float-right"
        @click="uploadFinalResumes"
        v-if="readyToSubmit"
        :loading="submitLoading"
        :text="$t(`${I18nPrefix}SUBMIT_FINAL_RESUMES`)"
      />
    </div>

    <soha-modal id="deleteMassResumeModal">
      <template v-slot:body>
        <div class="row justify-content-center">
          <p class="soha-delete-modal-text px-8 text-justify">
            {{ $t(`${I18nPrefix}REMOVE_PREVIOUS_RESUMES`) }}
          </p>
        </div>
        <div class="row mt-3 justify-content-center">
          <div class="d-flex">
            <soha-button
              name="cancel"
              @click="$bvModal.hide('deleteMassResumeModal')"
              class="mr-2"
              variant="danger"
              outline
              :text="$t(`${I18nPrefix}CANCEL_BTN_TXT`)"
            />
            <soha-button
              name="continue"
              @click="startUploading"
              class="ml-2"
              :text="$t(`${I18nPrefix}RETURN_BTN_TXT`)"
            />
          </div>
        </div>
      </template>
    </soha-modal>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import Loading from "@/view/components/base/Loading";
export default {
  name: "ResumeMassUpload",
  mixins: [UIMixin, ValidationMixin],
  components: { Loading },
  data() {
    return {
      I18nPrefix: "PAGES.RESUME.MASS_UPLOAD.",
      submitLoading: false,
      readyToUpload: false,
      readyToSubmit: false,
      readyToExtract: false,
      dontExtractResumeData: false,
      resumeFiles: [],
      response: [],
      errors: [],
      jobId: this.$route.query.jobId,
      jobTitle: this.$route.query.title,
      showPdfConfig: {
        toolbar: false,
      },
      fileIndex: 0,
    };
  },
  methods: {
    preventPageLeave(event) {
      event.returnValue = "write sth";
    },

    fileDropped(event) {
      event.preventDefault();
      event.currentTarget.classList.remove("soha-drag-active");
      this.$refs.massResumes.files = event.dataTransfer.files;
      this.filesSelected();
    },

    fileDragover(event) {
      event.preventDefault();
      event.currentTarget.classList.add("soha-drag-active");
    },

    fileDragleave(event) {
      event.currentTarget.classList.remove("soha-drag-active");
    },

    viewResumeFile(index) {
      for (let i = 0; i < this.response.length; i++) {
        if (i === index)
          this.response[index].showResumeFile =
            !this.response[index].showResumeFile;
        else this.response[i].showResumeFile = false;
      }
    },

    filesSelected() {
      if (this.response.length > 0 && !this.response[0].submitted) {
        this.$bvModal.show("deleteMassResumeModal");
      } else {
        this.startUploading();
      }
    },

    startUploading() {
      this.$bvModal.hide("deleteMassResumeModal");
      this.readyToUpload = true;
      this.readyToSubmit = false;
      this.response = [];
      this.errors = [];
      let len = this.$refs.massResumes.files.length;
      for (let i = 0; i < len; i++) {
        this.response.push({
          name: null,
          family: null,
          email: null,
          phone: null,
          resumeFileId: null,
          resumeText: null,
          fileUrl: null,
          showResumeFile: false,
          uploading: false,
          submitted: false,
        });
        this.errors.push({
          nameError: null,
          familyError: null,
          phoneError: null,
          emailError: null,
        });
      }

      let upload = true;
      this.resumeFiles = this.$refs.massResumes.files;
      for (let i = 0; i < this.resumeFiles.length; i++) {
        if (
          this.resumeFiles[i].name.substring(
            this.resumeFiles[i].name.length - 3,
            this.resumeFiles[i].name.length
          ) !== "pdf"
        ) {
          upload = false;
          break;
        }
      }

      if (upload) {
        window.addEventListener("beforeunload", this.preventPageLeave);
        for (let i = 0; i < this.response.length; i++) {
          this.response[i].uploading = true;
        }
        this.fileIndex = 0;
        this.uploadResumeFile();
      } else {
        this.errorToast(this.$t(`${this.I18nPrefix}PDF_TYPE_ERROR`));
        this.resumeFiles = [];
        this.response = [];
      }
    },

    uploadResumeFile() {
      if (this.fileIndex < this.resumeFiles.length) {
        let formData = new FormData();
        formData.append("file", this.resumeFiles[this.fileIndex]);
        ApiService.post("api/employer/uploadResume", formData).then((res) => {
          if (res.data.path) {
            this.response[this.fileIndex].fileUrl =
              this.$filesUrl + res.data.path;
            this.response[this.fileIndex].resumeFileId = res.data.resumeFileId;

            this.fileIndex += 1;
            this.uploadResumeFile();
          }
        });
      } else {
        this.fileIndex = 0;
        this.readyToExtract = true;
        this.readyToUpload = false;
        this.extractResumeData();
      }
    },

    extractResumeData() {
      if (this.fileIndex < this.resumeFiles.length) {
        if (!this.dontExtractResumeData) {
          const url =
            this.$textExtractorApi + this.response[this.fileIndex].fileUrl;
          this.axios
            .get(url)
            .then((response) => {
              this.response[this.fileIndex].name = response.data.name
                ? response.data.name
                : "";
              this.response[this.fileIndex].family = response.data.family
                ? response.data.family
                : "";
              this.response[this.fileIndex].email = response.data.email
                ? response.data.email
                : "";
              this.response[this.fileIndex].phone = response.data.phone
                ? response.data.phone
                : "";
              this.response[this.fileIndex].resumeText = response.data.text;
              this.response[this.fileIndex].uploading = false;
              this.readyToUpload = false;
              this.fileIndex += 1;
              this.extractResumeData();
            })
            .catch(() => {
              this.response[this.fileIndex].name = "";
              this.response[this.fileIndex].family = "";
              this.response[this.fileIndex].email = "";
              this.response[this.fileIndex].phone = "";
              this.response[this.fileIndex].resumeText = " ";
              this.response[this.fileIndex].uploading = false;
              this.readyToUpload = false;
              this.fileIndex += 1;
              this.extractResumeData();
            });
        } else {
          this.response[this.fileIndex].resumeText = " ";
          this.response[this.fileIndex].uploading = false;
          this.readyToUpload = false;
          this.fileIndex += 1;
          this.extractResumeData();
        }
      } else {
        this.readyToExtract = false;
        this.readyToSubmit = true;
      }
    },

    uploadFinalResumes() {
      if (this.validateResumesPersonalInfo()) return;

      this.submitLoading = true;
      for (let i = 0; i < this.response.length; i++) {
        let resume = this.response[i];

        const data = {
          result: {
            companyId: this.$route.query.companyId,
            jobId: this.$route.query.jobId,
            resumeFileId: resume.resumeFileId,
            resumeText: resume.resumeText,
            personalData: [
              {
                firstName: resume.name,
                lastName: resume.family,
                mobile: resume.phone,
                email: resume.email,
              },
            ],
          },
        };
        ApiService.post("api/employer/submitResume", data).then((response) => {
          if (response.data.status === "ok") {
            this.response[i].submitted = true;
            this.response[i].resumeText = "";
            if (i == this.response.length - 1) {
              this.submitLoading = false;
              this.readyToSubmit = false;
              this.successToast(
                this.$t(`${this.I18nPrefix}SUBMITTED_SUCCESSFULLY`)
              );
              setTimeout(() => {
                this.response = [];
                window.removeEventListener(
                  "beforeunload",
                  this.preventPageLeave
                );
                this.$router.push({
                  name: "job-pipeline-step",
                  query: {
                    id: this.jobId,
                  },
                });
              }, 2300);
            }
          }
        });
      }
    },

    validateResumesPersonalInfo() {
      let hasError = false;
      for (let i = 0; i < this.response.length; i++) {
        this.errors[i].nameError =
          this.errors[i].familyError =
          this.errors[i].phoneError =
          this.errors[i].emailError =
            null;
        let user = this.response[i];
        if (user.name === null || user.name == "") {
          this.errors[i].nameError = this.$t(`${this.I18nPrefix}NAME_ERROR`);
          hasError = true;
        } else this.errors[i].nameError = null;
        if (user.family === null || user.family == "") {
          this.errors[i].familyError = this.$t(
            `${this.I18nPrefix}FAMILY_ERROR`
          );
          hasError = true;
        } else this.errors[i].familyError = null;
        if (this.validatePhoneNumber(user.phone)) {
          this.errors[i].phoneError = this.$t(`${this.I18nPrefix}PHONE_ERROR`);
          hasError = true;
        } else this.errors[i].phoneError = null;
        if (user.email?.length > 0 && this.validateEmailFormat(user.email)) {
          this.errors[i].emailError = this.$t(`${this.I18nPrefix}EMAIL_ERROR`);
          hasError = true;
        }
      }
      return hasError;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.response.length > 0) {
      const answer = window.confirm(
        this.$t(`${this.I18nPrefix}ARE_YOU_SURE_TO_EXIT`)
      );
      if (answer) {
        window.removeEventListener("beforeunload", this.preventPageLeave);
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.soha-mass-upload-description {
  background-color: var(--light-secondary-color);
  border: 0.077rem solid var(--tag-light-blue-color);
}
.soha-draggable-card {
  border: 0.154rem dashed var(--box-border-color) !important;
  background: var(--muted-background-color);
  width: 100%;
  border-radius: 0.385rem;
  padding: 1.538rem;
  text-align: center;
}
.soha-upload-box-text {
  color: var(--primary-color);
  font-weight: bold;
}
.soha-file-text div:last-child {
  display: flex;
  justify-content: space-between;
}
.soha-attach-file-click {
  text-decoration: underline;
  font-style: italic;
}
.soha-attach-file-click:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
.soha-drag-active {
  background-color: var(--tag-light-green-color) !important;
}

.soha-mass-upload-pdf-box {
  width: 100%;
  overflow: hidden;
  border-width: 0;
  border-style: none;
  border-bottom: 0.077rem solid var(--box-border-color);
  border-color: var(--box-border-color);
}

.mass-resume-item-box {
  border: 0.077rem solid var(--box-border-color);
  border-radius: 0.385rem;
  width: 100%;
}
.soha-mass-upload-pdf-box ::-webkit-scrollbar {
  width: 0.769rem;
  display: none;
}
</style>
